<template>
  <div>
    <Headline :tag="headline.tag" :size="headline.size">
      <slot name="headline" />
    </Headline>
    <div class="mt-2">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import Headline from '../../../components/ui/headlines/Headline.vue'

export default defineComponent({
  name: 'ProductDetailGroup',
  components: {
    Headline,
  },
  props: {
    headline: {
      type: Object as PropType<{
        tag: string
        size: string
      }>,
      default: () => ({
        tag: 'p',
        size: 'sm',
      }),
    },
  },
})
</script>
